import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Course, Enum_Bookmark_Category } from '@edwin-group/people-graphql';
import LessonCard from '@/components/Learn/Lesson';
import useBookmark from '@/components/Bookmark/useBookmark';

export interface CourseBookmarkCardProps {
  course: Course;
  onRemoveFromBookmark?: () => void;
  removeFromBookmarksText: string;
  openButtonTxt: string;
}

export function CourseBookmarkCard({
  course,
  onRemoveFromBookmark,
  removeFromBookmarksText,
  openButtonTxt,
}: CourseBookmarkCardProps) {
  const { handleClick } = useBookmark({ relationId: course.documentId || '' });

  const buttonContent = useMemo(
    () => (
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        <Link
          to={`/learn/course/${course.slug || ''}`}
          className="font-haffer text-sh-12-18 font-bold text-dark-green hover:underline"
          aria-label={`Course: ${course.title}`}>
          {openButtonTxt}
        </Link>
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            handleClick(course, undefined, Enum_Bookmark_Category.Course, onRemoveFromBookmark);
          }}
          className="cursor-pointer border-0 bg-transparent p-0 font-haffer text-sh-12-18 font-bold text-dark-green hover:underline">
          {removeFromBookmarksText}
        </button>
      </div>
    ),
    [course, openButtonTxt, removeFromBookmarksText, handleClick, onRemoveFromBookmark],
  );

  return (
    <LessonCard
      title={course.title || ''}
      description={course.description || ''}
      thumbnail={course.thumbnail || undefined}
      url={`/learn/course/${course.slug || ''}`}
      duration={course.duration || undefined}
      button={buttonContent}
    />
  );
}
